/**
 * Created on 2025-06-16
 */
import React from 'react'
import { withStyles, WithStyles, createStyles } from '@material-ui/core'

const styles = createStyles({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: '26px 0 26px 0',
  },
  confirmModalHeader: {
    fontSize: '20px',
    fontWeight: 600,
    color: 'var(--color-oxford-blue)',
    lineHeight: '18px',
    padding: '0 24px',
    marginBottom: '16px',
  },
  confirmModalContent: {
    fontSize: '20px',
    color: 'var(--color-text-secondary)',
    marginTop: '24px',
    padding: '0 24px',
    lineHeight: '24px',
    marginBottom: '0px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
    padding: '0 24px',
    gap: '14px',
    borderTop: '1px solid #E0E0E0',
    paddingTop: '25px',
  },
  createButton: {
    padding: '8px 12px',
    border: 0,
    background: 'var(--color-button-primary)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-white)',
    fontSize: '16px',
    fontWeight: 500,
    width: '147px',
  },
  cancelButton: {
    padding: '8px 12px',
    border: '1px solid var(--color-button-primary)',
    background: 'var(--color-white)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-button-primary)',
    fontSize: '16px',
    fontWeight: 500,
    width: '147px',
  },
})

interface SupervisionDeleteModalProps extends WithStyles<typeof styles> {
  onConfirm: () => void
  onCancel: () => void
}

const SupervisionDeleteModal: React.FC<SupervisionDeleteModalProps> = ({ classes, onConfirm, onCancel }) => {
  return (
    <div className={classes.modalContainer}>
      <h2 className={classes.confirmModalHeader}>Delete supervision</h2>
      <p className={classes.confirmModalContent}>Are you sure you want to delete this supervision?</p>
      <div className={classes.buttonContainer}>
        <button className={classes.cancelButton} onClick={onCancel}>
          Cancel
        </button>
        <button className={classes.createButton} onClick={onConfirm}>
          Yes, delete
        </button>
      </div>
    </div>
  )
}

// PropTypes not needed with TypeScript interface

export default withStyles(styles, { withTheme: true })(SupervisionDeleteModal)
